module.exports = __webpack_public_path__ + "img/checkbox_on.135dd2dd.svg";